//--- React
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useQuery } from "@tanstack/react-query";
//--- Ant Design
import { Card, Col, Divider, Row, Select } from "antd";
//--- Project
import "./styles.css";
import PulseDateRange from "components/Common/DateRangeComponents/PulseDateRange";
import { getCompanies } from "apis/competitorPulseApis";
import { setPageLoader } from "reducers/loaderSlice";
//--- Icon
import MARKET_PULSE_ICON from "../../../assets/images/icons/MarketPulse.svg";
import REVIEW_COUNTS_ICON from "../../../assets/images/icons/review_counts.png";
import POSITIVE_ICON from "../../../assets/images/icons/positive-icon.svg";
import NEGATIVE_ICON from "../../../assets/images/icons/negative-icon.svg";

const CompanyFilter = ({
  filterValue,
  setFilterValue,
  onFilterChange,
  companyData,
}) => {
  const dispatch = useDispatch();
  const { data: companiesList, isLoading: companiesLoading } = useQuery({
    queryKey: ["companyList"],
    queryFn: () => getCompanies(),
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    dispatch(setPageLoader(companiesLoading ? "refresh" : null));
  });

  useEffect(() => {
    if (companiesList?.companies?.length > 0) {
      setFilterValue({
        company: companiesList.companies[0].company,
        minDate: companiesList.companies[0].min_date * 1000,
        maxDate: companiesList.companies[0].max_date * 1000,
        startDate: companiesList.companies[0].min_date * 1000,
        endDate: companiesList.companies[0].max_date * 1000,
        sourceList: null,
        bikeModel: null,
        sentiment: null,
      });
    }
  }, [companiesList, setFilterValue, dispatch]);

  return (
    <Card bordered={false} className="filter-box">
      <Row
        gutter={[16, 16]}
        justify={"space-around"}
        align={"middle"}
        className="mt05"
      >
        <Col xs={24} md={18} lg={14} className="">
          <div className="title">Market Pulse</div>
          <div className="title-content">
            AI analytics of user reviews in EV industry.
          </div>
        </Col>
        <Col xs={0} md={6} lg={10}>
          <img
            src={MARKET_PULSE_ICON}
            alt="market"
            height={68}
            className="float-right"
          />
        </Col>
      </Row>
      <Row justify={"center"}>
        <Col span={24}>
          <Divider />
        </Col>
      </Row>
      <Row gutter={[16, 16]} justify={"space-around"} className="mb05">
        <Col xs={24} sm={7} md={7} lg={7} xl={6}>
          <div className="lable">Company</div>
          <Select
            showSearch
            size="large"
            placeholder="Select a company"
            data-testid="market-company-dropdown"
            className="w100 mt05"
            value={filterValue.company}
            loading={companiesLoading}
            options={companiesList?.companies}
            fieldNames={{
              label: "company",
              value: "company",
              options: "options",
            }}
            onChange={(_, value) => onFilterChange("company", value)}
          />
        </Col>
        <Col xs={24} sm={7} md={10} lg={7} xl={6}>
          <div className="lable mb05">Date</div>
          <PulseDateRange
            dataTimeRange={[filterValue.minDate, filterValue.maxDate]}
            selectedTimeRange={[filterValue.startDate, filterValue.endDate]}
            onTimeFilterChange={(value) => onFilterChange("dates", value)}
          />
        </Col>
        <Col xs={24} sm={10} md={7} lg={10} xl={12} className="flex-end">
          <div className="review-count-box">
            <img
              src={REVIEW_COUNTS_ICON}
              alt="review count"
              className="review-icon"
            />
            <div>
              <div className="label">Reviews</div>
              <div className="count">{companyData?.total_reviews || 0}</div>
            </div>
            <div className="sentiment-box ml05">
              <div className="positive align-center">
                <img
                  src={POSITIVE_ICON}
                  alt="positive"
                  height={22}
                  width={22}
                />
                <span className="bold ml05">
                  {companyData?.positive_percentage}%
                </span>
              </div>
              <div className="negative align-center mt05">
                <img
                  src={NEGATIVE_ICON}
                  alt="Negative"
                  height={22}
                  width={22}
                />
                <span className="bold ml05">
                  {companyData?.negative_percentage}%
                </span>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default CompanyFilter;
